






























import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { MungBeanAllocateBatchList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import MungBeanAllocateBatchDetailDialog from './MungBeanAllocateBatchDetailDialog.vue'

@Component({
  components: { VQuery, VTable, MungBeanAllocateBatchDetailDialog },
})
export default class MungBeanAllocateBatchListPage extends Vue {
  private queryParam: any = {
    startRow: 1,
    limit: 10,
    createTimeDaterange: [],
  }
  private tableTotal = 0
  private tableData: any[] = []
  private tableCurrntPage = 1
  private pageSummary: any = null

  private queryModels: Array<QueryModel> = [
    { title: '批次号', param: 'batchNo' },
    { title: '标的用户ID', param: 'targetUserId' },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange' },
  ]

  private queryOperation: Array<TableOperation> = []

  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index', width: 56 },
    { title: '批次号', param: 'batchNo', minWidth: 200, overflow: true },
    { title: '标的用户ID', param: 'targetUserId', minWidth: 110 },
    { title: '标的用户', param: 'targetUserNickname', minWidth: 120 },
    { title: '直推池', param: 'directPool', minWidth: 90 },
    { title: '十代池', param: 'tenGenPool', minWidth: 90 },
    { title: '输入池合计', param: 'poolInputSum', minWidth: 100 },
    { title: '直推本人获得', param: 'directNonIdentityQty', minWidth: 110 },
    { title: '实发合计', param: 'totalPaidQty', minWidth: 90 },
    { title: '沉淀合计', param: 'totalSedimentQty', minWidth: 90 },
    { title: '状态', param: 'statusLabel', minWidth: 80 },
    { title: '规则版本', param: 'ruleVersion', minWidth: 180, overflow: true },
    { title: '操作人ID', param: 'operatorId', minWidth: 90 },
    { title: '备注', param: 'note', minWidth: 140, overflow: true },
    { title: '创建时间', param: 'createTime', minWidth: 160, formatter: DateFormat },
    {
      title: '操作',
      width: 100,
      fixed: 'right',
      operation: [{ title: '查看详情', click: this.openDetail }],
    },
  ]

  public activated() {
    this.loadData()
  }

  public created() {
    this.loadData()
  }

  public async loadData() {
    const param = this.getRequestParam()
    const result = await MungBeanAllocateBatchList(param)
    const list = result.list || []
    this.tableTotal = result.total || 0
    this.tableData = list.map((row: any) => ({
      ...row,
      poolInputSum: this.calcPoolInputSum(row),
    }))
    this.pageSummary = this.buildPageSummary(list)
  }

  private calcPoolInputSum(row: any) {
    const d = parseFloat(row.directPool) || 0
    const t = parseFloat(row.tenGenPool) || 0
    return (d + t).toFixed(2)
  }

  private buildPageSummary(list: any[]) {
    if (!list || list.length === 0) {
      return null
    }
    let directPoolSum = 0
    let tenGenPoolSum = 0
    let paidSum = 0
    let sedimentSum = 0
    for (const row of list) {
      directPoolSum += parseFloat(row.directPool) || 0
      tenGenPoolSum += parseFloat(row.tenGenPool) || 0
      paidSum += parseFloat(row.totalPaidQty) || 0
      sedimentSum += parseFloat(row.totalSedimentQty) || 0
    }
    return {
      batchCount: list.length,
      directPoolSum: directPoolSum.toFixed(2),
      tenGenPoolSum: tenGenPoolSum.toFixed(2),
      paidSum: paidSum.toFixed(2),
      sedimentSum: sedimentSum.toFixed(2),
    }
  }

  private getRequestParam() {
    const param: any = { ...this.queryParam }
    if (param.createTimeDaterange && param.createTimeDaterange.length > 0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    delete param.createTimeDaterange
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 10)
    return param
  }

  public openDetail(data: any) {
    const ref: any = this.$refs.batchDetailRef
    if (ref && ref.open) {
      ref.open(data)
    }
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }

  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
